import { LoadState } from "../../../constants/enums";
import { initialLeadHabitationalApplicationState } from "./leadHabitationalApplication.types";
import {
  FETCH_LEAD_HABITATIONAL_APPLICATION_FAILED,
  FETCH_LEAD_HABITATIONAL_APPLICATION_PROGRESS,
  FETCH_LEAD_HABITATIONAL_APPLICATION_SUCCESS,
  CLEAR_LEAD_HABITATIONAL_APPLICATION_STATE,
} from "./leadHabitationalApplicationActions";

export const leadHabitationalApplicationReducer = (
  state = initialLeadHabitationalApplicationState,
  action: { type: string; payload?: any }
) => {
  switch (action.type) {
    case FETCH_LEAD_HABITATIONAL_APPLICATION_PROGRESS:
      return {
        ...state,
        loading: LoadState.InProgress,
      };
    case FETCH_LEAD_HABITATIONAL_APPLICATION_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        loading: LoadState.Loaded,
      };
    case FETCH_LEAD_HABITATIONAL_APPLICATION_FAILED:
      return {
        ...state,
        loading: LoadState.Failed,
      };
    case CLEAR_LEAD_HABITATIONAL_APPLICATION_STATE:
      return initialLeadHabitationalApplicationState;
    default:
      return state;
  }
};
